import { feeds } from "../../apis/services";
import { FETCH_SPONSORS } from "../../constants/sponsors";

export const fetchSponsorsConfig = () => ({
  type: FETCH_SPONSORS,
  payload: feeds.getSponsorsConfig(),
});
